<template>
    <div>
        <div class="kit__utils__heading">
            <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
        </div>
        <div class="card">
            <div class="card-header card-header-flex">
                <search v-bind="sentDataSearch"></search>
            </div>

        </div>

        <div class=" mb-4">
            <a-row :gutter="16" gr>
                <a-col  :xs="{span: 24}" :lg="{span: 12}">
                    <a-card title="ยอดรวมการเติมเงินของเว็บ" :bordered="true">
                        <div class="d-flex flex-row justify-content-around align-items-center">
                            <div class="d-flex flex-column justify-content-center align-items-center">
                                <span class="h2">{{ dataSumDepositWeb.countDeposit === null ? 0 : dataSumDepositWeb.countDeposit}}</span>
                                <small>เติม/ครั้ง</small>
                            </div>
                            <div class="d-flex flex-column justify-content-center align-items-center">
                                <span class="h2">{{ dataSumDepositWeb.sumDeposit === null ? 0 : dataSumDepositWeb.sumDeposit }}</span>
                                <small>เติม/บาท</small>
                            </div>
                        </div>
                    </a-card>
                </a-col>
                <a-col  :xs="{span: 24}" :lg="{span: 12}">
                    <a-card title="ยอดรวมการถอนเงินของเว็บ" :bordered="true">
                        <div class="d-flex flex-row justify-content-around align-items-center">
                            <div class="d-flex flex-column justify-content-center align-items-center">
                                <span class="h2">{{ dataSumWithdrawWeb.countWithdraw === null ? 0 : dataSumWithdrawWeb.countWithdraw}}</span>
                                <small>ถอน/ครั้ง</small>
                            </div>
                            <div class="d-flex flex-column justify-content-center align-items-center">
                                <span class="h2">{{ dataSumWithdrawWeb.sumWithdraw === null ? 0 : dataSumWithdrawWeb.sumWithdraw}}</span>
                                <small>ถอน/บาท</small>
                            </div>
                        </div>
                    </a-card>
                </a-col>
            </a-row>
        </div>

        <div class=" mb-4">
          <a-card title="ยอดรวมการ Settle" :bordered="true">
            <div class="d-flex flex-row justify-content-around align-items-center">
              <div class="d-flex flex-column justify-content-center align-items-center">
                <span class="h2">{{ dataSumSettleWeb.countSettle === null ? 0 : dataSumSettleWeb.countSettle}}</span>
                <small>settle/ครั้ง</small>
              </div>
              <div class="d-flex flex-column justify-content-center align-items-center">
                <span class="h2">{{ dataSumSettleWeb.sumSettle === null ? 0 : dataSumSettleWeb.sumSettle }}</span>
                <small>settle/บาท</small>
              </div>
            </div>
          </a-card>
        </div>

        <div class="card">
            <div class="card-body">
                <tableReport titleTable="ยอดรวมการเติมเงินแยกตาม PartnerSBO"
                :dataSource="dataSumDepositByPartnerSBO"
                :columns="columnsSumDepositByPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="ยอดรวมการถอนเงินแยกตาม PartnerSBO"
                :dataSource="dataSumWithdrawByPartnerSBO"
                :columns="columnsSumWithdrawByPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="ยอดรวมการเติมเงินแยกตาม Provider"
                :dataSource="dataSumDepositByProvider"
                :columns="columnsSumDepositByProvider"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="ยอดรวมการถอนเงินแยกตาม Provider"
                :dataSource="dataSumWithdrawByProvider"
                :columns="columnsSumWithdrawByProvider"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card" v-for="(item, index) in providers" :key="index">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="item.name"
                :dataSource="dataByPartnerSBO[`dataSumByProviderAndPartnerSBO_${item.name}`]"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <!-- <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`Peer2Pay`"
                :dataSource="dataSumByProviderAndPartnerSBO_Peer2Pay"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`HengPay`"
                :dataSource="dataSumByProviderAndPartnerSBO_HengPay"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`ThaiKing`"
                :dataSource="dataSumByProviderAndPartnerSBO_Thaiking"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`Capital Pay`"
                :dataSource="dataSumByProviderAndPartnerSBO_CapitalPay"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`First2Pay`"
                :dataSource="dataSumByProviderAndPartnerSBO_First2Pay"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`Alphapay`"
                :dataSource="dataSumByProviderAndPartnerSBO_Alphapay"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`PaPaYaPay`"
                :dataSource="dataSumByProviderAndPartnerSBO_PapayaPay"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`MTPay`"
                :dataSource="dataSumByProviderAndPartnerSBO_MTPay"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`OFFPay`"
                :dataSource="dataSumByProviderAndPartnerSBO_OFFPay"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`SmailPay`"
                :dataSource="dataSumByProviderAndPartnerSBO_SmailPay"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`OkPay`"
                :dataSource="dataSumByProviderAndPartnerSBO_OkPay"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <tableReport titleTable="รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO"
                :providerName="`bitPay`"
                :dataSource="dataSumByProviderAndPartnerSBO_bitPay"
                :columns="columnsSumDepositAndWithdrawByProviderAndPartnerSBO"
                :isLoading="isLoading"
                @load-data="getData"></tableReport>
            </div>
        </div> -->
    </div>
  </template>

<script>
import { mapGetters } from 'vuex'
import apiClient from '@/services/api'
import tableReport from './table'
import search from '@/components/system/table/search/sbo/report'
import momentTz from 'moment-timezone'
export default {
  components: {
    tableReport,
    search,
  },
  watch: {
    getStartDate: function(val) {
      if (val) {
        this.getData()
      }
    },
    getEndDate: function(val) {
      if (val && !this.checkFistPage) {
        this.getData()
      }
      if (this.checkFistPage) this.checkFistPage = false
    },
    getSearchUpdate: function(val) {
      if (val) {
        this.getData()
      }
    },
    selectedRowKeys: function(val) {
      if (val) {
        this.dataToExcel(val)
      }
    },
  },
  data() {
    return {
      isLoading: false,
      pageType: 'reportPaymentGateway',
      dataSumDepositWeb: {},
      dataSumWithdrawWeb: {},
      dataSumSettleWeb: {},
      dataByPartnerSBO: [],
      providers: [],
      dataSumDepositByPartnerSBO: {
        rowKey: 'dataSumDepositByPartnerSBO',
        data: [],
        fileName: 'ยอดรวมการเติมเงินแยกตาม PartnerSBO' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          พาร์ทเนอร์: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countDepositByPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumDepositByPartnerSBO',
        },
      },
      dataSumWithdrawByPartnerSBO: {
        rowKey: 'dataSumWithdrawByPartnerSBO',
        data: [],
        fileName: 'ยอดรวมการถอนเงินแยกตาม PartnerSBO' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          พาร์ทเนอร์: 'partnerSBOName',
          จำนวนครั้งการถอนเงิน: 'countWithdrawByPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByPartnerSBO',
        },
      },
      dataSumDepositByProvider: {
        rowKey: 'dataSumDepositByProvider',
        data: [],
        fileName: 'ยอดรวมการเติมเงินแยกตาม Provider' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ผู้ให้บริการ: 'providerName',
          จำนวนครั้งการเติมเงิน: 'countDepositByProvider',
          จำนวนเงินการเติมเงิน: 'sumDepositByProvider',
        },
      },
      dataSumWithdrawByProvider: {
        rowKey: 'dataSumWithdrawByProvider',
        data: [],
        fileName: 'ยอดรวมการถอนเงินแยกตาม Provider' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ผู้ให้บริการ: 'providerName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProvider',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProvider',
        },
      },
      dataSumDepositByProviderAndPartnerSBO: {
        rowKey: 'dataSumDepositByProviderAndPartnerSBO',
        data: [],
        fileName: 'ยอดรวมการเติมเงินแยกตาม Provider และ PartnerSBO' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ผู้ให้บริการ: 'providerName',
          พาร์ทเนอร์: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countDepositByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumDepositByProviderAndPartnerSBO',
        },
      },
      dataSumWithdrawByProviderAndPartnerSBO: {
        rowKey: 'dataSumWithdrawByProviderAndPartnerSBO',
        data: [],
        fileName: 'ยอดรวมการถอนเงินแยกตาม Provider และ PartnerSBO' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ผู้ให้บริการ: 'providerName',
          พาร์ทเนอร์: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_Peer2Pay: {
        rowKey: 'dataSumByProviderAndPartnerSBO_Peer2Pay',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO Peer2Pay' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_HengPay: {
        rowKey: 'dataSumByProviderAndPartnerSBO_HengPay',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO HengPay' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_Thaiking: {
        rowKey: 'dataSumByProviderAndPartnerSBO_Thaiking',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO Thaiking' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_CapitalPay: {
        rowKey: 'dataSumByProviderAndPartnerSBO_CapitalPay',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO CapitalPay' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_First2Pay: {
        rowKey: 'dataSumByProviderAndPartnerSBO_First2Pay',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO First2Pay' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_Alphapay: {
        rowKey: 'dataSumByProviderAndPartnerSBO_Alphapay',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO Alphapay' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_PapayaPay: {
        rowKey: 'dataSumByProviderAndPartnerSBO_PapayaPay',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO PapayaPay' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_MTPay: {
        rowKey: 'dataSumByProviderAndPartnerSBO_MTPay',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO MTPay' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_OFFPay: {
        rowKey: 'dataSumByProviderAndPartnerSBO_OFFPay',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO OFFPay' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_SmailPay: {
        rowKey: 'dataSumByProviderAndPartnerSBO_SmailPay',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO SmailPay' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_OkPay: {
        rowKey: 'dataSumByProviderAndPartnerSBO_OkPay',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO OkPay' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      dataSumByProviderAndPartnerSBO_bitPay: {
        rowKey: 'dataSumByProviderAndPartnerSBO_bitPay',
        data: [],
        fileName: 'รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO bitPay' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
        json_fields: {
          ชื่อpartner: 'partnerSBOName',
          จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
          จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
          จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
          จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
        },
      },
      columnsSumDepositByPartnerSBO: [
        {
          title: 'พาร์ทเนอร์',
          key: 'partnerSBOName',
          dataIndex: 'partnerSBOName',
          width: 200,
        },
        {
          title: 'จำนวนครั้งการเติมเงิน',
          key: 'countDepositByPartnerSBO',
          dataIndex: 'countDepositByPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'จำนวนเงินการเติมเงิน',
          key: 'sumDepositByPartnerSBO',
          dataIndex: 'sumDepositByPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
      ],
      columnsSumWithdrawByPartnerSBO: [
        {
          title: 'พาร์ทเนอร์',
          key: 'partnerSBOName',
          dataIndex: 'partnerSBOName',
          width: 200,
        },
        {
          title: 'จำนวนครั้งการถอนเงิน',
          key: 'countWithdrawByPartnerSBO',
          dataIndex: 'countWithdrawByPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'จำนวนเงินการถอนเงิน',
          key: 'sumWithdrawByPartnerSBO',
          dataIndex: 'sumWithdrawByPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
      ],
      columnsSumDepositByProvider: [
        {
          title: 'ผู้ให้บริการ',
          key: 'providerName',
          dataIndex: 'providerName',
          width: 200,
        },
        {
          title: 'จำนวนครั้งการเติมเงิน',
          key: 'countDepositByProvider',
          dataIndex: 'countDepositByProvider',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'จำนวนเงินการเติมเงิน',
          key: 'sumDepositByProvider',
          dataIndex: 'sumDepositByProvider',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
      ],
      columnsSumWithdrawByProvider: [
        {
          title: 'ผู้ให้บริการ',
          key: 'providerName',
          dataIndex: 'providerName',
          width: 200,
        },
        {
          title: 'จำนวนครั้งการถอนเงิน',
          key: 'countWithdrawByProvider',
          dataIndex: 'countWithdrawByProvider',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'จำนวนเงินการถอนเงิน',
          key: 'sumWithdrawByProvider',
          dataIndex: 'sumWithdrawByProvider',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
      ],
      columnsSumDepositByProviderAndPartnerSBO: [
        {
          title: 'ผู้ให้บริการ',
          key: 'providerName',
          dataIndex: 'providerName',
          width: 200,
        },
        {
          title: 'พาร์ทเนอร์',
          key: 'partnerSBOName',
          dataIndex: 'partnerSBOName',
          width: 200,
        },
        {
          title: 'จำนวนครั้งการเติมเงิน',
          key: 'countDepositByProviderAndPartnerSBO',
          dataIndex: 'countDepositByProviderAndPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'จำนวนเงินการเติมเงิน',
          key: 'sumDepositByProviderAndPartnerSBO',
          dataIndex: 'sumDepositByProviderAndPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
      ],
      columnsSumWithdrawByProviderAndPartnerSBO: [
        {
          title: 'ผู้ให้บริการ',
          key: 'providerName',
          dataIndex: 'providerName',
          width: 200,
        },
        {
          title: 'พาร์ทเนอร์',
          key: 'partnerSBOName',
          dataIndex: 'partnerSBOName',
          width: 200,
        },
        {
          title: 'จำนวนครั้งการเติมเงิน',
          key: 'countWithdrawByProviderAndPartnerSBO',
          dataIndex: 'countWithdrawByProviderAndPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'จำนวนเงินการเติมเงิน',
          key: 'sumWithdrawByProviderAndPartnerSBO',
          dataIndex: 'sumWithdrawByProviderAndPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
      ],
      columnsSumDepositAndWithdrawByProviderAndPartnerSBO: [
        {
          title: 'ชื่อ Partner',
          key: 'partnerSBOName',
          dataIndex: 'partnerSBOName',
          width: 200,
        },
        {
          title: 'จำนวนการเติมเงิน/ครั้ง',
          key: 'countDepositByProviderAndPartnerSBO',
          dataIndex: 'countDepositByProviderAndPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'จำนวนการเติมเงิน/บาท',
          key: 'sumDepositByProviderAndPartnerSBO',
          dataIndex: 'sumDepositByProviderAndPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'จำนวนถอนเงิน/ครั้ง',
          key: 'countWithdrawByProviderAndPartnerSBO',
          dataIndex: 'countWithdrawByProviderAndPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'จำนวนถอนเงิน/บาท',
          key: 'sumWithdrawByProviderAndPartnerSBO',
          dataIndex: 'sumWithdrawByProviderAndPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'จำนวนSettleเงิน/ครั้ง',
          key: 'countSettleByProviderAndPartnerSBO',
          dataIndex: 'countSettleByProviderAndPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'จำนวนเงินSettle/บาท',
          key: 'sumSettleByProviderAndPartnerSBO',
          dataIndex: 'sumSettleByProviderAndPartnerSBO',
          width: 200,
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
      ],
    }
  },
  computed: {
    sentDataSearch: function() {
      return {
        pageType: this.pageType,
      }
    },
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
    }),

  },
  methods: {
    numberWithCommas(x) {
      if (x) {
        return x.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return x
      }
    },
    async getData() {
      this.isLoading = !this.isLoading

      const dataDeposit = await {
        startDate: this.getStartDate,
        endDate: this.getEndDate,
      }

      await apiClient.post('/reportPaymentGateway/getData', dataDeposit).then(response => {
        this.isLoading = !this.isLoading
        const res = response.data
        if (res.code === '000') {
          this.providers = res.responseData.data.providers
          this.dataSumDepositWeb = res.responseData.data.dataSumDepositWeb[0]
          this.dataSumDepositWeb.countDeposit = this.numberWithCommas(this.dataSumDepositWeb.countDeposit)
          this.dataSumDepositWeb.sumDeposit = this.numberWithCommas(this.dataSumDepositWeb.sumDeposit)

          this.dataSumWithdrawWeb = res.responseData.data.dataSumWithdrawWeb[0]
          this.dataSumWithdrawWeb.countWithdraw = this.numberWithCommas(this.dataSumWithdrawWeb.countWithdraw)
          this.dataSumWithdrawWeb.sumWithdraw = this.numberWithCommas(this.dataSumWithdrawWeb.sumWithdraw)

          this.dataSumSettleWeb = res.responseData.data.dataSumSettleWeb[0]
          this.dataSumSettleWeb.countSettle = this.numberWithCommas(this.dataSumSettleWeb.countSettle)
          this.dataSumSettleWeb.sumSettle = this.numberWithCommas(this.dataSumSettleWeb.sumSettle)

          this.dataSumDepositByPartnerSBO.data = res.responseData.data.dataSumDepositByPartnerSBO
          this.dataSumWithdrawByPartnerSBO.data = res.responseData.data.dataSumWithdrawByPartnerSBO
          this.dataSumDepositByProvider.data = res.responseData.data.dataSumDepositByProvider
          this.dataSumWithdrawByProvider.data = res.responseData.data.dataSumWithdrawByProvider

          this.dataSumDepositByProviderAndPartnerSBO.data = res.responseData.data.dataSumDepositByProviderAndPartnerSBO
          this.dataSumWithdrawByProviderAndPartnerSBO.data = res.responseData.data.dataSumWithdrawByProviderAndPartnerSBO

          res.responseData.data.providers.forEach((provider) => {
            const dynamicKey = `dataSumByProviderAndPartnerSBO_${provider.name}`
            const initData = {
              rowKeyName: provider.name,
              rowKey: dynamicKey,
              data: res.responseData.data.dataSumByProviderAndPartnerSBO[provider.name] ? res.responseData.data.dataSumByProviderAndPartnerSBO[provider.name] : [],
              fileName: `รายการเติมเงิน ถอนเงิน แยกตาม Provider และ PartnerSBO ${provider.name} ` + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
              json_fields: {
                ชื่อคู่ค้า: 'partnerSBOName',
                จำนวนครั้งการเติมเงิน: 'countWithdrawByProviderAndPartnerSBO',
                จำนวนเงินการเติมเงิน: 'sumWithdrawByProviderAndPartnerSBO',
                จำนวนครั้งการถินเงิน: 'countWithdrawByProviderAndPartnerSBO',
                จำนวนเงินการถอนเงิน: 'sumWithdrawByProviderAndPartnerSBO',
                จำนวนครั้งการSettle: 'countSettleByProviderAndPartnerSBO',
                จำนวนเงินการSettle: 'sumSettleByProviderAndPartnerSBO',
              },
            }
            if (initData.data.length > 0) {
              const bitPayIndex = this.providers.findIndex(item => item.name === provider.name)
              if (bitPayIndex !== -1) {
                // Extract the object
                const bitPay = this.providers.splice(bitPayIndex, 1)[0]

                // Add it to the beginning of the array
                this.providers.unshift(bitPay)
              }
            }

            this.$set(this.dataByPartnerSBO, dynamicKey, initData)
          })
        }
      })
    },
  },
}
</script>

  <style>

  </style>
